$(document).ready(function () {

  var checkboxAddCard = $("#add_card");
  var shippingFields = $(".shipping-fields");
  var mandatoryFields = shippingFields.find('input[type="text"]');
  var checkoutButton = $('.cart__checkout');
  
  [
    "#shipping_name",
    "#shipping_time",
    "#shipping_address",
    "#shipping_phone",
    "#CartSpecialInstructions"

  ].forEach(function(selector) {
    
    var field = $(selector)
    	.on('keyup change', onFieldChange)
    	.on('focus', onFieldFocus)
    	.on('blur', onFieldBlur);
    
    updateFieldLabel(field);
  });
  
  checkoutButton.on('click', function(event) {
    
    if(!canCheckout()) {
      return false;
    }

  });
  checkoutButton.on('keypress', function(event) {
    if(event.which == 13 && !canCheckout()) {
      return false;
    }
  });
  
  checkboxAddCard.on('keypress', function(event) {
    if(event.which === 13) {
      checkboxAddCard.click();
      return false;
    }
  });
  
  mandatoryFields.on('keypress', function(event) {
    if(event.which === 13) {
      return false;
    }
  });

  function onFieldChange() {
    updateFieldLabel($(this));
  }
  
  function onFieldFocus() {
   	$(this).closest(".field").addClass("field__active"); 
  }
  
  function onFieldBlur() {
   	$(this).closest(".field").removeClass("field__active"); 
  }

  function updateFieldLabel(field)  {

    var floatingLabelClass = "field--show-floating-label";

    if((field.val() || '').length > 0) {
      field.closest(".field").addClass(floatingLabelClass);
    }
    else {
      field.closest(".field").removeClass(floatingLabelClass); 
    }
  }

  function canCheckout() {

    var fieldsValid = true;

    mandatoryFields.each(function(index, element) {

      if((element.value ||'').trim().length === 0) {
        element.focus();
        checkoutButton.removeClass('btn--loading');
        fieldsValid = false;
        return false;
      }

    });

    return fieldsValid;
  }

});

// Limit card message length
$(document).ready(function () {
  var limit = 200;
  var $note = $('#CartSpecialInstructions');

  if ($note.length) {
    $note.attr('maxlength', limit);

    var $counter = $('<div style="font-size:12px; opacity:0.6; margin-top:6px;"></div>');
    $note.after($counter);

    function updateCounter() {
      var remaining = limit - $note.val().length;
      $counter.text(remaining + " / " + limit + " rakstzīmes");
    }

    $note.on('input keyup change', updateCounter);
    updateCounter();
  }
});
